import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetAllUser = () => {
  return (
    API_GET(API.GetAllUsers)
  )
}


